module.exports = __webpack_public_path__ + "static/floating-action-button-position-do-f177cd6feeaeb0fc20f2f3ab7e6ee8dd.png";